import { Component, Vue, Model } from "vue-property-decorator";

import { SocialProgram } from "@/models/SocialProgram";
import { SocialProgramSubscriptionType } from "@/enums/SocialProgramSubscriptionType";

import Notifications from "@/views/social-program/notifications/Notifications.vue";

@Component({
  components: {
    notification: Notifications
  }
})
export default class SocialPrograms extends Vue {
  @Model("input", { type: String }) search!: string;

  selectedSubscriptionType = "All";
  SocialProgramSubscriptionType = SocialProgramSubscriptionType;
  subscriptionTypes = ["All", ...Object.values(SocialProgramSubscriptionType)];

  public get headers() {
    return [
      {
        text: "",
        sortable: false,
        width: 70,
        value: "imageUrl"
      },
      {
        text: this.$i18n.messages[this.$i18n.locale]['SocialProgramsList.Name'],
        align: "start",
        sortable: false,
        value: "name"
      },
      {
        text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Dimension'],
        value: "category"
      }
    ];
  }

  public get socialPrograms(): SocialProgram[] {
    return this.$store.state.socialClubModule.socialClubs;
  }

  get facility() {
    return this.$store.state.facilityModule.selectedFacility;
  }

  public created(): void {
    this.$store.dispatch("getSocialClubs");
    this.$store.dispatch("getFacility");

    if(this.facility?.isOptInLifestylePrograms){
      this.headers.push({
        text: this.$i18n.messages[this.$i18n.locale]['SocialProgramsList.NoOfMembers'],
        value: "members.length"
      })
    }
  }

  public handleClickSocialClub({ id }): void {
    this.$router.push({
      name: "SocialProgramView",
      params: {
        id
      }
    });
  }
}
